import { createTheme } from '@mui/material/styles';
import { grey, blue } from '@mui/material/colors';

export const theme = createTheme({
    palette: {
        primary: {
            main: blue['600'],
            second: grey['100']
        },
        secondary: {
            main: "#edf2ff"
        },
        error: {
            main: "#DA1E28"
        }
    },
    typography: {
        // iOS에서 일관된 폰트 렌더링을 위한 폰트 스택 개선
        fontFamily: [
            'Pretendard-Regular',
            '-apple-system',
            'BlinkMacSystemFont',
            'Apple SD Gothic Neo',
            '"Apple Color Emoji"',
            'Noto Sans KR',
            'Malgun Gothic',
            'sans-serif'
        ].join(","),

        // 전역 Typography 설정
        allVariants: {
            textRendering: 'optimizeLegibility',
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
            fontFeatureSettings: '"kern" 1, "liga" 1',
            fontVariantNumeric: 'lining-nums'
        },

        // 각 variant별 iOS 최적화 설정
        h1: {
            lineHeight: 1.2,
            letterSpacing: '-0.02em'
        },
        h2: {
            lineHeight: 1.2,
            letterSpacing: '-0.02em'
        },
        h3: {
            lineHeight: 1.2,
            letterSpacing: '-0.01em'
        },
        h4: {
            lineHeight: 1.2,
            letterSpacing: '-0.01em',
            // iOS에서 특히 문제가 되는 h4 타입을 위한 특별 설정
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        h5: {
            lineHeight: 1.25,
            letterSpacing: '-0.005em'
        },
        h6: {
            lineHeight: 1.25,
            letterSpacing: '0em'
        },
        body1: {
            lineHeight: 1.5,
            letterSpacing: '-0.01em'
        },
        body2: {
            lineHeight: 1.5,
            letterSpacing: '-0.005em'
        },
        button: {
            lineHeight: 1.2,
            letterSpacing: '0.02em'
        }
    },

    // MUI 컴포넌트별 기본 스타일 오버라이드
    components: {
        // Typography 컴포넌트 글로벌 스타일
        MuiTypography: {
            styleOverrides: {
                root: {
                    // iOS에서 일관된 텍스트 렌더링
                    WebkitTextSizeAdjust: '100%',
                    textRendering: 'optimizeLegibility',
                    WebkitFontSmoothing: 'antialiased',
                    MozOsxFontSmoothing: 'grayscale',

                    // iOS Safari 전용 스타일
                    '@supports (-webkit-touch-callout: none)': {
                        // iOS에서만 적용되는 미세 조정
                        transform: 'translateZ(0)', // 하드웨어 가속 활성화
                    }
                },
                h4: {
                    // h4에 특별한 정렬 설정 (헤더에서 주로 사용)
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',

                    // iOS에서만 적용되는 추가 조정
                    '@supports (-webkit-touch-callout: none)': {
                        lineHeight: '1.15 !important'
                    }
                }
            }
        },

        // Input 필드 내 텍스트 정렬
        MuiInputBase: {
            styleOverrides: {
                input: {
                    display: 'flex',
                    alignItems: 'center',
                    lineHeight: '1.2 !important',
                    WebkitAppearance: 'none',
                    WebkitTextFillColor: 'inherit',

                    // iOS Safari에서의 추가 조정
                    '@supports (-webkit-touch-callout: none)': {
                        transform: 'translateY(0.5px)'
                    }
                }
            }
        },

        // Button 내 텍스트 정렬
        MuiButton: {
            styleOverrides: {
                root: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1.2,

                    // iOS에서 버튼 텍스트 미세 조정
                    '@supports (-webkit-touch-callout: none)': {
                        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                            display: 'flex',
                            alignItems: 'center'
                        }
                    }
                }
            }
        },

        // IconButton 정렬
        MuiIconButton: {
            styleOverrides: {
                root: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }
            }
        }
    },

    maxWidth: {
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1800,
        xll: 1920,
    },
    width: '100%',
    margin: '0 auto',
    padding: '0',
    boxSizing: 'border-box'
});